// @flow
import ButtonsExtended from './ButtonsExtended';

export default ButtonsExtended;
